import React from "react";
import { ArrowLeft } from "lucide-react";

const PaymentMethodSelection = ({ onMethodSelect, selectedMethod }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border">
      {/* Header */}
      <div className="px-6 py-4 border-b">
        <h1 className="text-xl font-semibold">Payment Setup</h1>
        <div className="w-full bg-gray-200 h-1 mt-2">
          <div className="bg-black h-1 w-1/3"></div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="mb-6">
          <h2 className="text-lg font-medium mb-2">Payment Setup</h2>
          <p className="text-gray-600">Set up your payment method for receiving payments</p>
        </div>

        <div className="mb-8">
          <p className="text-gray-600 mb-6">
            Select how you would like to receive payments. This will be synced with Paystack for processing.
          </p>

          <div className="space-y-4">
            {/* Bank Account Option */}
            <div
              className="border rounded-lg p-4 cursor-pointer hover:bg-gray-50"
              onClick={() => onMethodSelect("bank")}
            >
              <div className="flex items-center">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="bank"
                  checked={selectedMethod === "bank"}
                  onChange={() => onMethodSelect("bank")}
                  className="mr-3"
                />
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-blue-100 rounded flex items-center justify-center mr-3">
                    <div className="w-4 h-4 bg-blue-500 rounded"></div>
                  </div>
                  <div>
                    <div className="font-medium">Bank Account</div>
                    <div className="text-sm text-gray-600">Receive payments directly to your bank account</div>
                  </div>
                </div>
              </div>
            </div>

            {/* M-Pesa Paybill Option */}
            <div
              className="border rounded-lg p-4 cursor-pointer hover:bg-gray-50"
              onClick={() => onMethodSelect("paybill")}
            >
              <div className="flex items-center">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="paybill"
                  checked={selectedMethod === "paybill"}
                  onChange={() => onMethodSelect("paybill")}
                  className="mr-3"
                />
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-green-100 rounded flex items-center justify-center mr-3">
                    <div className="w-4 h-4 bg-green-500 rounded"></div>
                  </div>
                  <div>
                    <div className="font-medium">M-Pesa Paybill</div>
                    <div className="text-sm text-gray-600">Receive payments via M-Pesa Paybill number</div>
                  </div>
                </div>
              </div>
            </div>

            {/* M-Pesa Till Number Option */}
            <div
              className="border rounded-lg p-4 cursor-pointer hover:bg-gray-50"
              onClick={() => onMethodSelect("till")}
            >
              <div className="flex items-center">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="till"
                  checked={selectedMethod === "till"}
                  onChange={() => onMethodSelect("till")}
                  className="mr-3"
                />
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-green-100 rounded flex items-center justify-center mr-3">
                    <div className="w-4 h-4 bg-green-500 rounded"></div>
                  </div>
                  <div>
                    <div className="font-medium">M-Pesa Till Number</div>
                    <div className="text-sm text-gray-600">Receive payments via M-Pesa Till number</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex justify-between">
          <button className="flex items-center text-gray-600 hover:text-gray-800">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Previous
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodSelection;
